// @flow
import React, {useContext, useEffect, useRef, useState} from "react";
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import {Redirect, useLocation} from "react-router-dom";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import {gotCompletedBTOs, gotUnpickedBTOs} from "../ACTIONS/clientActions";
import ArchiverClientApi from "../API/archiverClientApi";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import BackNextWidget from "../GUI_COMMON/COMPONENTS/BackNextWidget";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useCookies} from "react-cookie";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import SampleSearchInput from "./SampleSearchInput";
import {useHistory} from "react-router";
import BTOCardRow from "./BTOCardRow";
import ReloadButton from "../GUI_COMMON/COMPONENTS/ReloadButton";
import {DepartmentWithLocation} from "../GUI_COMMON/SUPPORT/MagazineV2";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";

export type Actor = {
    id: number,
    fullName: string,
    phone: string,
    email: string,
    locations: [],
    // and others
}

export type DestinationDepartment = {
    id: number,
    isEnabled: boolean,
    name: string,
    notes: string,
    parentLocationId: number
}
export type DestinationLocation = {
    id: number,
    isEnabled: boolean,
    name: string,
    notes: string,
    offPremises: boolean,
    address: string,
    departments: DestinationDepartment[]
}

export type BTOOrderModel = {
    id: number,
    isPickCompleted: boolean,
    notes: string,
    dateStarted: string,
    datePickCompleted: string,
    dateModified: string,
    dateMoved: string,
    creator: Actor,
    requester: Actor,
    destinationLocation: string,
    destinationDepartment: DestinationDepartment,
}

const BTOsPage = () => {

    const BTO_PAGE_SIZE = 25;

    const [globalState, dispatch] = useContext(StoreContext);
    const [isLoadingUnpicked, setIsLoadingUnpicked] = useState(false);
    const [isLoadingCompleted, setIsLoadingCompleted] = useState(false);
    const [isExportingBtoId, setIsExportingBtoId] = useState(null);
    const [isDeleteShippingId, setIsDeleteShippingId] = useState(null);       
    const [unpickedList, setUnpickedList] = useState([]);
    const [completedList, setCompletedList] = useState([]);
    const [redirectTo, setRedirectTo] = useState();

    const [startIndex, setStartIndex] = useState(0);

    const location = useLocation();
    const history = useHistory();

    const [cookies,] = useCookies();
    const unpickedRef = useRef();
    const completedRef = useRef();

    const [activePageRef, setActivePageRef] = useState();
    const [forceRefresh, setForceRefresh] = useState(false);


    useEffect(() => {
        hideAllTabPages();
        const pageAnchor = location.hash.replace("#", "");
        if (pageAnchor === "unpicked") {
            showTabPage(unpickedRef);
        } else if (pageAnchor === "completed") {
            showTabPage(completedRef);
        } else {
            showTabPage(unpickedRef);
        }

        setForceRefresh(true);

    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (globalState.btos.unpicked) {
            const listCopy = [...globalState.btos.unpicked];
            listCopy.forEach(item => item.isChecked = false);  // augment
            setUnpickedList(listCopy);
            resetSelectAllCB();
        }
    }, [globalState.btos.unpicked]);
    useEffect(() => {
        if (globalState.btos.completed) {
            setCompletedList(globalState.btos.completed);
        }
    }, [globalState.btos.completed]);
    useEffect(() => {
        if (activePageRef === unpickedRef) {
            loadUnpickedBTOs(forceRefresh);
            setForceRefresh(false);
        } else if (activePageRef === completedRef) {
            loadCompletedBTOsAtIndex(0, BTO_PAGE_SIZE);
            setForceRefresh(false);
        }
    }, [activePageRef]); // eslint-disable-line react-hooks/exhaustive-deps

    //#region LOADERS

    function loadUnpickedBTOs(loadCompletedAfter = true) {
        setIsLoadingUnpicked(true);
        ArchiverClientApi.getBTOs("unpicked", 0, 1000)
        .then((orders) => {
            dispatch(gotUnpickedBTOs(orders));
            
            if (loadCompletedAfter === true) {
                loadCompletedBTOsAtIndex();  // now load completed
            }
        })
        .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally(() => setIsLoadingUnpicked(false));
    }

    function loadCompletedBTOsAtIndex(startIndex = 0, numToReturn = BTO_PAGE_SIZE) {

        setStartIndex(startIndex);
        setIsLoadingCompleted(true);
        ArchiverClientApi.getBTOs("completed", startIndex, numToReturn)
        .then((orders:BTOOrderModel[]) => {
            dispatch(gotCompletedBTOs(orders));
        })
        .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally(() => setIsLoadingCompleted(false));
    }

    //#endregion LOADERS

    function handleOrderCheckChanged(orderItem, isChecked) {
        let curList = [...unpickedList];
        let theOrder = curList.find(item => item.id === orderItem.id);
        theOrder.isChecked = isChecked;
        setUnpickedList(curList);
    }

    function handleGotoOrder(orderId) {
        setRedirectTo(`/btos/details/${orderId}`);
    }

    function resetSelectAllCB() {
        const cb = document.getElementById("unpicked-select-all-cb");
        if (cb) {
            cb.checked = false;
        }
    }

    function handleSelectAllCBChanged() {
        const isChecked = document.getElementById("unpicked-select-all-cb").checked;

        let curList = [...unpickedList];
        curList.forEach(item => item.isChecked = isChecked);
        setUnpickedList(curList);
    }

    function handleDeleteClicked(item) {
        const orderNum = LIUtils.prettyOrderNumber(item.id);
        Popup.showConfirm("", `Really delete order '${orderNum}'?`, "Yes, Delete!", () => {
        }, () => { // do it
            setIsDeleteShippingId(item.id);
            ArchiverClientApi.sendDeleteBTORequest(item.id)
            .then(({numPickedRemaining}) => {
                if (numPickedRemaining > 0) { // couldn't delete full RO
                    showBTONotDeleted(numPickedRemaining);
                } else { // reload ### for now
                    loadUnpickedBTOs(false);
                }
            })       // don't refresh the unsent
            .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
            .finally(() => {
                setIsDeleteShippingId(null);
            });
        }, null, null, "No");
    }

    function handleCancelOrderClicked(item) {
        const orderNum = LIUtils.prettyOrderNumber(item.id);
        Popup.showConfirm("", `<p>Really cancel '${orderNum}'?  It will be returned to the 'Unpicked' list.</p>`
            + `<p>You can cancel this order until ${LIUtils.dateTimeToPretty(LIUtils.dateFromJsonUtcDateStr(item.cancelTimeIfPicked))}`
            + ", after which it will be locked.</p>", 
            "Yes, Cancel!", () => {}, () => { // do it
            setIsDeleteShippingId(item.id);
            ArchiverClientApi.sendDeleteBTORequest(item.id)
            .then(({numPickedRemaining, orderCancelled, orderDeleted}) => {
                if (numPickedRemaining > 0 || !orderCancelled) { // couldn't cancel (had unpicked objects or was outside the time window) 
                    showBTONotDeleted(numPickedRemaining);
                } else { // reload ### for now
                    loadUnpickedBTOs(true);
                }
            })       // don't refresh the unsent
            .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
            .finally(() => {
                setIsDeleteShippingId(null);
            });
        }, null, null, "No, don't cancel");
    }
    
    function handleShipNowClicked(item:BTOOrderModel) {
        const orderNum = LIUtils.prettyOrderNumber(item.id);
        Popup.showConfirm("", `<p>Really ship '${orderNum}'? </p>`
            + "<p> This will begin the process of moving all boxes, magazines, and samples to the new location, which ordinarily happens when the cancel time expires.</p>"
            + "<p>This cannot be undone.</p>",
            "Yes, Ship It!", () => {}, () => { // do it
                setIsDeleteShippingId(item.id);
                ArchiverClientApi.startBTOLocationChangesNowForOrder(item.id)
                .then(() => {
                    updateCancelTimeForOrder(item.id); // locally only.
                })       
                .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
                .finally(() => {
                    setIsDeleteShippingId(null);
                });
            }, null, null, "No");
    }
    
    function updateCancelTimeForOrder(orderId) {
        const curList = [...completedList];
        const theOrder = curList.find(item => item.id === orderId);
        theOrder.cancelTimeIfPicked = new Date().toJSON();
        setCompletedList(curList);
    }

    function handleExportClicked(item) {

        setIsExportingBtoId(item.id);
        ArchiverClientApi.requestExportFileForBTO(item.id)
        .then(() => {
            Popup.show("Order Exported", `The order was exported and saved to your local 'Downloads' folder.`, null);
        })       // don't refresh the unsent
        .catch(responseError => {
            ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError);
        })
        .finally(() => {
            setIsExportingBtoId(null); // none
        });
    }

    function showBTONotDeleted(numPickedRemaining) {
        ErrorPopup.showError("Order Not Deleted", 
            `<p>There were ${numPickedRemaining} magazines <strong>already picked</strong> in this order.</p>` + 
            "<p>You will need to revisit the order, <strong>remove and return each picked mag to its original location</strong>, and " + 
            "then delete the order once again.</p>" + 
            "<p>* Any unpicked mags have already been removed from this order for you.</p>", null);
    }

    function showUnpickedBTOsList(pList) {
        if (!pList || pList.length === 0) {
            return <>
                <div className="card text-center li-bg-light mt-5">No UNPICKED orders found</div>
            </>
        }

        const resultRows = pList.map((item) => {
            const destinationLocation: DepartmentWithLocation = {
                location: item.destinationLocation, department: item.destinationDepartment
            };
            return (<BTOCardRow key={item.id} orderNumber={item.id}
                                dateStarted={item.dateStarted}
                                createdBy={item.creator}
                                requestedBy={item.requester}
                                destinedForLocation={destinationLocation}
                                notes={item.notes}
                                showCheckBox isChecked={item.isChecked}
                                onClick={() => handleGotoOrder(item.id)}
                                onCheckChanged={(isChecked) => handleOrderCheckChanged(item, isChecked)}
                                allowDelete onDeleteClicked={() => handleDeleteClicked(item)}
                                deleteShipIsBusy={isDeleteShippingId === item.id}
            />);
        });

        return (<>
                <table id="unpickedTable" className="table table-striped li-bg-white">
                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" className="m-2 mr-3 border-bottom" id="unpicked-select-all-cb"
                                       aria-label="Checkbox" onChange={handleSelectAllCBChanged}/>
                            </th>
                            <th>Order#</th>
                            <th>Date Started</th>
                            <th>Requested By</th>
                            <th>Created By</th>
                            <th>Destined For</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultRows}
                    </tbody>
                </table>
            </>);
    }

    function showCompletedBTOsList(pList) {
        if (!pList || pList.length === 0) {
            return <div className="card text-center li-bg-light mt-5">No COMPLETED orders found</div>;
        }
        
        const resultRows = pList.map((item, index) => {
            const destinationLocation: DepartmentWithLocation = {
                location: item.destinationLocation, department: item.destinationDepartment
            };
            const canCancelOrder: boolean = !item.dateMoved &&LIUtils.canCancelOrder(LIUtils.dateFromJsonUtcDateStr(item.cancelTimeIfPicked));
            return (<BTOCardRow key={item.id} orderNumber={item.id}
                                dateStarted={item.datePickCompleted}  // dateCompleted here rather than dateStarted (same column)
                                createdBy={item.creator}
                                requestedBy={item.requester}
                                destinedForLocation={destinationLocation}
                                notes={item.notes}
                                onClick={() => handleGotoOrder(item.id)}
                                showExportButton exportClicked={() => handleExportClicked(item)}
                                exportIsBusy={isExportingBtoId === item.id}
                                allowDelete={canCancelOrder} onDeleteClicked={() => handleCancelOrderClicked(item)}
                                allowShipNow={canCancelOrder} onShipNowClicked={() => handleShipNowClicked(item)}
                                deleteShipIsBusy={isDeleteShippingId === item.id}
                />
            );          
        });

        return (<table id="completedTable" className="table table-striped">
                <thead>
                    <tr className="li-bg-pale-ok">
                        <th width="100px">Order#</th>
                        <th width="25px"></th>
                        <th>Date Completed</th>
                        <th>Requested By</th>
                        <th>Created By</th>
                        <th>Destined For</th>
                        <th>Notes</th>
                    </tr>
                </thead>
                <tbody>
                    {resultRows}
                </tbody>
            </table>

        );
    }

    function handleCompletedBTOsBackNext(startIndex, numToReturn) {
        loadCompletedBTOsAtIndex(startIndex, numToReturn);
    }

    function aUnpickedIsSelected(): boolean {
        return !!unpickedList.find(item => item.isChecked);
    }

    function showGeneratePickSheet() {
        let isDisabled = true;
        if (aUnpickedIsSelected()) {
            isDisabled = false;
        }
        return (<button className="li-button li-primary mb-2 mt-0" disabled={isDisabled}
                        onClick={handleGeneratePickSheet}>Generate Pick Sheet</button>);
    }

    function handleGeneratePickSheet() {

        if (LIUtils.UserHasLevel(cookies, "STORAGE_ADMIN") || LIUtils.UserHasLevel(cookies, "SAMPLE_PICKER")) {
            const pickSheetItems = unpickedList?.filter(item => item.isChecked) ?? [];
            let pickList = "";
            pickSheetItems.forEach(item => {
                console.debug(`picking order: ${item.id}`);
                pickList += item.id + ",";
            });
            setRedirectTo("/btos/pick_sheet?" + pickList);
        } else {
            Popup.show("", "<p>You are not a STORAGE ADMIN orSAMPLE PICKER type user.</p>" + 
                "Talk to your Archiver Administrator if you wish to change this.");
        }
    }

    function showAddOrderButton() {
        if (!LIUtils.UserHasLevel(cookies, "STORAGE_ADMIN")) {
            return null;
        }
        return (<button className="li-button li-bg-success li-fg-white align-self-center mr-4" id="addOrderBtn"
                        onClick={() => setRedirectTo("/btos/new")}>
                <i className="fa fa-plus mr-2 font-weight-bold"/>Order
            </button>);
    }

    //#region TAB_HANDLERS
    function hideAllTabPages() {
        hideTabPage(unpickedRef);
        hideTabPage(completedRef);
    }

    function hideTabPage(pageRef) {
        if (pageRef && pageRef.current) {
            pageRef.current.classList.remove("show");
            pageRef.current.classList.remove("active");
            pageRef.current.classList.add("hide");
            pageRef.current.style.display = "none";
        }
    }

    function showTabPage(pageRef) {

        if (activePageRef && activePageRef.current && activePageRef.current === pageRef.current) {
            console.debug("showTabPage() called for same page we are already on");
            return; // already on this page
        }

        // remove active page info
        hideTabPage(activePageRef);

        if (pageRef && pageRef.current) {
            setActivePageRef(pageRef)
            // show the page we want
            pageRef.current.classList.remove("hide");
            pageRef.current.classList.add("show");
            pageRef.current.classList.add("active");
            pageRef.current.style.display = "block";
            const tabId = pageRef.current.id;
            history.replace(`/btos#${tabId}`);
        }
    }

    //#endregion TAB_HANDLERS

    if (redirectTo) {
        return (<Redirect push to={redirectTo}/>);
    }

    function showUnpickedTabHeader() {
        if (isLoadingUnpicked) {
            return (<div className="d-inline-block">Unpicked
                <span className="d-inline-block ml-2">
                        <i className="d-block fa fa-spinner fa-pulse fa-fw"/>
                    </span>
            </div>);
        }
        return <>Unpicked ({unpickedList?.length ?? "-"})</>;
    }

    function showCompletedTabHeader() {
        if (isLoadingCompleted) {
            return (<div className="d-inline-block">Completed
                <span className="d-inline-block ml-2">
                        <i className="d-block fa fa-spinner fa-pulse fa-fw"/>
                    </span>
            </div>);
        }
        return <>Completed ({completedList?.length ?? "-"})</>;
    }

    return (

        <div className="container">
            <Header title="Box Transfer Orders"/>
            <div className="row li-header-row m-0 p-0 justify-content-between">
                <div>
                    <BackButton onClick={() => setRedirectTo('/dashboard')}/>
                    <h1 className="d-inline-block align-middle">Box Transfer Orders</h1>
                </div>

                <div className="align-content-center">
                    <SampleSearchInput onSearchClicked={handleGotoOrder} name="findOrderInput" placeholder="order #"
                                       right small/>
                </div>
                {showAddOrderButton()}
            </div>

            {/* TABS */}
            <div className="d-flex justify-content-between">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item mr-2" role="presentation">
                        <button className={"nav-link li-font-medium " + (activePageRef === unpickedRef ? "active" : "")}
                                id="unpicked-tab" onClick={() => showTabPage(unpickedRef)}>
                            <i className={"fa fa-clipboard-check mr-2 " + (activePageRef === unpickedRef ? "" : "li-fg-primary")}/>{showUnpickedTabHeader()}
                        </button>
                    </li>
                    <li className="nav-item mr-2 li-font-medium " role="presentation">
                        <button className={"nav-link " + (activePageRef === completedRef ? "active" : "")}
                                id="completed-tab" onClick={() => showTabPage(completedRef)}>
                            <i className={"fa fa-check mr-2 " + (activePageRef === completedRef ? "" : "li-fg-primary")}/>{showCompletedTabHeader()}
                        </button>
                    </li>
                </ul>
                <div className="text-right">
                    <LIButton bgClass="li-primary" faIcon="fa fa-box-open" small label="Box History" labelLeft={false}
                              tooltip="search box history" onClick={() => setRedirectTo('/box_search')}/>
                    <ReloadButton/>
                </div>

            </div>

            {/* TAB CONTENT */}
            <div id="unpicked" className="tab-pane fade" ref={unpickedRef}>
                <div className="text-right">
                    <div className="d-inline-block mt-4 mr-3">{showGeneratePickSheet()}</div>
                </div>
                <div className="mt-3 mb-2">
                    {showUnpickedBTOsList(unpickedList)}
                </div>
            </div>

            <div id="completed" className="tab-pane fade" ref={completedRef}>
                <div className="mt-3 mb-2">
                    {showCompletedBTOsList(completedList)}
                    <BackNextWidget disableNext={completedList.length < BTO_PAGE_SIZE} pageSize={BTO_PAGE_SIZE}
                                    show={completedList.length >= BTO_PAGE_SIZE}
                                    startIndex={startIndex} onClick={handleCompletedBTOsBackNext}/>
                </div>
            </div>
        </div>);
}

export default BTOsPage;